module.exports = __webpack_public_path__ + "static/img/pc-10.24d78ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/h5/pc-10.jpg
// module id = h7Xg
// module chunks = 1